import {shouldShowDualCurrencyExchangeRate} from '@ampeco/currency';

interface UseDualCurrencyExchangeRateProps {
  currencyId: number | undefined;
  operatorCountry?: string | null;
}

export const useDualCurrencyExchangeRate = ({
  currencyId,
  operatorCountry
}: UseDualCurrencyExchangeRateProps) => {
  return {
    shouldShowDualCurrencyExchangeRate: shouldShowDualCurrencyExchangeRate({
      currencyId,
      operatorCountry
    })
  };
};
